<mat-card class="default has-progress-bar" [class.compact]="compact">
  <mat-progress-bar mode="determinate"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ 'payments.charge.collect-payment' | translate }}</span>
    <span fxFlex></span>
    <!-- PIA-3384: legacy ppal.atlassian.net article returns 401 to clinic users -->
    <!-- <a
      mat-icon-button
      [matTooltip]="'common.help-center' | translate"
      matTooltipPosition="above"
      href="https://ppal.atlassian.net/wiki/spaces/KB/pages/622610/Collecting+Payments"
      target="_blank"
    ><mat-icon>help</mat-icon></a> -->
  </mat-card-title>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
    <mat-tab
      [label]="'payments.charge.direct-payment' | translate"
      *ngIf="!invoice.plan && chargeForm"
    >
      <form [formGroup]="chargeForm"  (ngSubmit)="validateCharge(false)"  autocomplete="off">
        <mat-card-content fxLayout="column">
          <div
            *ngIf="clinic.modules.billing"
            class="mb-05"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <mat-radio-group
              formControlName="paymentMethod"
              (change)="setPaymentMethod()"
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutGap="1rem"
            >
              <mat-radio-button color="primary" value="creditCard">{{
                'payments.charge.credit-card' | translate
              }}</mat-radio-button>
              <mat-radio-button color="primary" value="check">{{
                'payments.charge.check' | translate
              }}</mat-radio-button>
              <mat-radio-button color="primary" value="cash">{{
                'payments.charge.cash' | translate
              }}</mat-radio-button> </mat-radio-group
            ><br />
            <div *ngIf="clinic.modulesPreferences.promptPayments">
              <mat-checkbox
                formControlName="isDiscount"
                color="primary"
                (change)="changeDiscount()"
                [disabled]="invoice.amountPaid > 0"
              >
                {{ 'payments.charge.apply-discount' | translate }} ({{
                  clinic.modulesPreferences.promptPaymentDiscount
                }}%)
              </mat-checkbox>
            </div>
          </div>

          <mat-form-field
            *ngIf="chargeForm.value.paymentMethod === 'creditCard'"
            fxFlex
            class="mt-6"
          >
            <mat-label>{{ 'payments.charge.credit-card' | translate }}</mat-label>
            <mat-select formControlName="creditCard">
              <mat-select-trigger
                fxLayout="row"
                fxLayoutAlign="start center"
                *ngIf="chargeForm.get('creditCard').value as creditCardForm"
              >
                <ng-container *ngIf="creditCardForm === 'new'; else cardTemplate">
                  {{ 'dialog.transaction.add-card' | translate }}
                </ng-container>

                <ng-template #cardTemplate>
                  <div fxFlex>
                    {{ card?.lastFourDigits | creditCardNumber }}
                  </div>
                  <div fxLayoutAlign="center center">
                    <div *ngIf="card?.expiryDate">
                      {{ card?.expiryDate }}
                    </div>
                    <div *ngIf="!card?.expiryDate">
                      {{ card?.expirationMonth }} /
                      {{ card?.expirationYear }}
                    </div>
                    <img
                      *ngIf="card"
                      class="credit-card-icon"
                      [src]="card | cardImage"
                    />
                    <span *ngIf="card?.funding"
                    >{{ card.funding | mmxTitlecase }}
                    </span>
                  </div>
                </ng-template>
              </mat-select-trigger>
              <mat-option
                *ngFor="let card of creditCards"
                [value]="card.id"
                [matTooltip]="'payments.charge.provider-by' | translate: { value: card.provider.toUpperCase() }"
              >
                <div class="card-details">
                  <div fxFlex>{{ card.lastFourDigits | creditCardNumber }}</div>
                  <div>{{ card.expiryDate }}</div>
                  <img class="credit-card-icon" [src]="card | cardImage" />
                  <span *ngIf="card.funding">{{ card.funding | mmxTitlecase }}</span>
                </div>
              </mat-option>
              <mat-option value="new">
                <mat-icon>add</mat-icon>
                {{ 'payments.charge.add-card' | translate }}
              </mat-option>
            </mat-select>
            <mat-hint>{{
              'payments.charge.select-card-saved' | translate
              }}</mat-hint>
            <mat-error
              *ngIf="
                  chargeForm.get('creditCard').invalid &&
                  chargeForm.get('creditCard').touched
                "
            >{{
              getErrorMessage('cardNumber', 'Card Number')
              }}</mat-error
            >
          </mat-form-field>

          <ng-container *ngIf="chargeForm.value.creditCard === 'new'">
            <mat-form-field class="mt-3" fxFlex>
              <mat-label>{{ 'dialog.transaction.name-on-card'  | translate }}</mat-label>
              <input matInput formControlName="holderName">

              <mat-error *ngIf="chargeForm.get('holderName').invalid && chargeForm.get('holderName').touched">
                {{ getErrorMessage('holderName', 'Name') }}
              </mat-error>
            </mat-form-field>

            <ng-container *ngIf="clinic.paymentProvider.selectedProvider === 'tilled'">
              <mat-form-field fxFlex>
                <mat-label>{{ 'common.email' | translate }}</mat-label>
                <input matInput formControlName="email">
              </mat-form-field>

              <mat-form-field fxFlex>
                <mat-label>Billing Address</mat-label>
                <mmx-address-field formControlName="holderAddress"></mmx-address-field>
              </mat-form-field>
            </ng-container>

            <mmx-payment-card-form
              class="mt-3"
              [providerConfiguration]="paymentProviderConfiguration"
              [formConfiguration]="cardFormConfiguration"
              [clientName]="clinic.name"
              (formUpdated)="paymentFormUpdated()">
            </mmx-payment-card-form>
          </ng-container>

          <mat-form-field
            *ngIf="chargeForm.value.paymentMethod === 'check'"
            fxFlex
            class="mt-6"
          >
            <mat-label>{{ 'payments.charge.check-number' | translate }}</mat-label>
            <input
              matInput
              placeholder="1000"
              formControlName="checkNumber"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <mat-hint>{{ 'payments.charge.check-number-hint' | translate }}</mat-hint>
            <mat-error *ngIf="chargeForm.controls.checkNumber.invalid">{{
              getErrorMessage('checkNumber', 'Check Number')
            }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex class="mt-3">
            <mat-label>{{ 'payments.charge.amount' | translate }}</mat-label>
            <input
              matInput
              placeholder="10.00"
              formControlName="amount"
              [maskito]="amountMask"
            />
            <mat-error
              *ngIf="
                  chargeForm.get('amount').invalid &&
                  chargeForm.get('amount').touched
                "
            >{{
              getErrorMessage('amount', 'Amount')
              }}</mat-error
            >
          </mat-form-field>

          <mat-form-field *ngIf="!patient?.email" fxFlex>
            <mat-label>{{ 'payments.charge.patient-email' | translate }}</mat-label>
            <input matInput type="email" formControlName="patientEmail" />
          </mat-form-field>

          <div fxFlex>
            <mat-slide-toggle
              formControlName="areNotesVisibleToPatient"
              color="primary"
              [matTooltip]="'payments.charge.private-note-tooltip' | translate"
              class="mb-4"
            >
              {{ 'payments.charge.private-note' | translate }}
            </mat-slide-toggle>
          </div>

          <mat-form-field fxFlex>
            <mat-label>{{ 'payments.charge.notes' | translate }}</mat-label>
            <textarea matInput formControlName="notes"></textarea>
            <mat-hint>{{ 'payments.charge.notes-hint' | translate }}</mat-hint>
          </mat-form-field>

          <mmx-custom-fields-form
            fxFlex
            *ngIf="customFields.transactionFields$ | async as fields"
            [fields]="fields"
            formControlName="customFields"
            class="mt-4"
          ></mmx-custom-fields-form>

          <div
            *ngIf="hold"
            fxLayout="row"
            class="text-bold"
            fxLayoutAlign="center"
          >
            {{ 'payments.charge.on-hold-message' | translate }}&nbsp;
            <span *ngIf="invoice.pastDue"> 11:45 PM {{ 'common.today' | translate }}</span>
            <span *ngIf="!invoice.pastDue && invoice.dueDays < 7">
               11:45 PM {{ 'common.on' | translate }} {{ invoice.dueDate | momentDate }}
            </span>
            <span *ngIf="!invoice.pastDue && invoice.dueDays >= 7">11:45 PM {{ 'common.today' | translate }}</span>
            &nbsp;{{ 'payments.charge.on-hold-refund-message' | translate }}
          </div>
        </mat-card-content>

        <mat-card-actions fxLayout="row" fxLayoutGap="1rem">
        <button
          mat-flat-button
          type="submit"
          color="primary"
          [disabled]="isSaving || chargeCaptured">
          {{ 'payments.charge.charge' | translate }}
          {{ safeCurrency(chargeForm.value.amount) | currency: invoice.currency }}
        </button>
        <button *ngIf="hold"
          mat-flat-button
          type="button"
          color="primary"
          [disabled]="isSaving || chargeCaptured"
          (click)="validateCharge(true)">
          {{ 'payments.charge.place-hold' | translate }}
          {{ safeCurrency(chargeForm.value.amount) | currency: invoice.currency }}
        </button>
        </mat-card-actions>
      </form>
      <div
        fxLayout="row"
        [class]="responseColor"
        fxLayoutAlign="center"
        *ngIf="serverResponse"
      >
        {{ serverResponse | translate }}
      </div>
    </mat-tab>

    <mat-tab
      *ngIf="clinic.modules.billing"
      [label]="'payments.charge.payment-plan' | translate"
    >
    <mmx-payment-plan-form
      *ngIf="showPaymentPlan.available; else paymentPlanUnavailable"
      [patient]="patient"
      [appointment]="appointment"
      [invoice]="invoice"
      [chargeAmount]="chargeAmount"
      (newCharge)="newCharge.emit($event)"
    ></mmx-payment-plan-form>

    <ng-template #paymentPlanUnavailable>
      <mat-card-content fxLayout="column" fxLayoutAlign="center center" class="mt-6 mb-6">
        <mat-icon class="large-icon mb-2">info</mat-icon>
        <div class="text-center">
          {{ 'payments.charge.payment-plan-unavailable' | translate }}
          <br />
          <span *ngIf="showPaymentPlan.reason === 'disabled'">
            {{ 'payments.charge.payment-plan-disabled' | translate }}
          </span>
          <span *ngIf="showPaymentPlan.reason === 'amount-too-low'">
            {{ 'payments.charge.payment-plan-amount-too-low' | translate: { minAmount: clinic.modulesPreferences.minLoanAmount | currency: invoice.currency } }}
          </span>
        </div>
      </mat-card-content>
    </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
